import React from 'react';
import DropArea from '../DropArea';
import { DnD_element_type_menu, getAllTypes_menu, getAllTypes, DnD_element_type } from '../common/ConstantValues';
import DnDOverContent from '../common/DnDOverContent'

const InitMessageDropArea = (props) => {
  const { onMessageDropped } = props
  const { minHeight, index, placeholder } = props
  const onDropped = (e) => {
    onMessageDropped({
      ...e,
      index: index
    })
  }
  return (
    <DropArea 
      onDrop={onDropped}
      overContent={DnDOverContent}
      overContentArg={{
        minHeight: minHeight ? minHeight : 200,
        paddingTop: minHeight ? minHeight / 2 - 10 : 85
      }}
      acceptTypes={getAllTypes.filter((type) => type !== DnD_element_type_menu.ELEMENT.SLIDE_PAGE).filter((type) => type !== DnD_element_type.ELEMENT.SLIDE_PAGE)} // Except `SLIDE_PAGE`
      placeholder={placeholder}
    />
  )
}

export default InitMessageDropArea